import { render, staticRenderFns } from "./InvoicePage.vue?vue&type=template&id=6d63d943&scoped=true&"
import script from "./InvoicePage.vue?vue&type=script&lang=js&"
export * from "./InvoicePage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePage.vue?vue&type=style&index=0&id=6d63d943&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63d943",
  null
  
)

export default component.exports